$(document).ready(function () {
  $('.product-slick h3').each(function () {
    $(this).nextUntil('.product-slick h3').wrapAll('<div class="tab-container"></div>');
  });

  $('.tab-container').wrapAll('<div class="slider-for"></div>')

  $('.product-slick h3').each(function(){
    var getText = $(this).text();

    $('.slider-nav').append('<h2><span>'+getText+'</span></h2>');
  });

  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.slider-nav',
    adaptiveHeight: true
  });
  $('.slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    infinite: false,
    arrows: true
  });

  // $("h2").nextUntil("h2").wrap('<div class="tab-container"></div>');

  // $('.tab-container').siblings('.tab-container').wrapAll("<div class='tab-container__container'></div>");


  $('.dynamic-products__slider').slick({
    dots: true,
    arrows: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 768,
        settings: 'unslick'
      }
    ]
  });
});